import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { NotificationEnum } from '../enums/notification.enum';
import { InstantNotificationsQueryParams } from '../model/instant-notifications-query-params';
import { NotificationElement } from '../model/notificationElement';
import { PagedResult } from '../model/paged-result';
import { ReservationDetailsTabType } from './../../_modules/reservations/enum/resDetailsTabsType.enum';
import { ApiUrlService } from './api-url.service';
import { HttpClientService } from './service-clients/http-client.service';

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {
    private httpClient = inject(HttpClientService);
    private helper = inject(ApiUrlService);

    public getNotifications(bsid: number, qp: InstantNotificationsQueryParams): Observable<PagedResult<NotificationElement>> {
        // TODO se doda nov tip notifikacij za PREVENTIVNI, ko delavcu poteče PERIODIKA
        const url = this.helper.getAssistanceUrl(2) + `bs/${bsid}/notifications`;
        const params = this.buildNotificationsParams(qp);

        return this.httpClient.get(url, { params }) as Observable<PagedResult<NotificationElement>>;
    }

    public markNotificationAsSeen(bsid: number, notificationId: number) {
        return this.httpClient.put(this.helper.getAssistanceUrl(2) + `bs/${bsid}/notifications/${notificationId}`);
    }
    public markAllNotificationsAsSeen(bsid: number) {
        return this.httpClient.put(this.helper.getAssistanceUrl(2) + `bs/${bsid}/notifications`);
    }
    public prepareNotifications(list: NotificationElement[]): NotificationElement[] {
        const allowedTypes = new Set<NotificationEnum>([
            NotificationEnum.RESERVATION_CANCELED,
            NotificationEnum.CASE_CANCELED,
            NotificationEnum.ASISTANT_CASE_CONTRACTOR_COMMENT_ADDED,
            NotificationEnum.ASISTANT_CASE_CONTRACTOR_DOCUMENT_ADDED,
        ]);

        return list
            .filter((n): n is NotificationElement => n != null && n.type != null && allowedTypes.has(n.type))
            .map(n => this.decorateNotification(n));
    }

    private decorateNotification(notification: NotificationElement): NotificationElement {
        switch (notification?.type) {
            case NotificationEnum.RESERVATION_CANCELED:
            case NotificationEnum.CASE_CANCELED:
                _.set(notification, 'data.msg', 'Termin preklican');
                return notification;
            case NotificationEnum.ASISTANT_CASE_CONTRACTOR_COMMENT_ADDED:
                _.set(notification, 'data.msg', 'Prejeto novo sporočilo izvajalca');
                _.set(notification, 'tab', ReservationDetailsTabType.COMMUNICATION);
                return notification;
            case NotificationEnum.ASISTANT_CASE_CONTRACTOR_DOCUMENT_ADDED:
                _.set(notification, 'data.msg', 'Prejeto zdravniško spričevalo');
                _.set(notification, 'tab', ReservationDetailsTabType.REPORT);
                return notification;
            default:
                return notification;
        }
    }

    private buildNotificationsParams(qp: InstantNotificationsQueryParams): HttpParams {
        let params = new HttpParams();

        params = params.append('from', qp.from);
        params = params.append('to', qp.to);

        if (qp.page !== undefined && qp.page !== null) params = params.append('page', String(qp.page));
        if (qp.pageSize !== undefined && qp.pageSize !== null) params = params.append('pageSize', String(qp.pageSize));

        if (qp.types?.length) {
            // Micronaut supports repeated query params for lists: types=A&types=B...
            qp.types.forEach(t => {
                params = params.append('types', t);
            });
        }

        return params;
    }
}
